import React from 'react';
import { Breadcrumb, Grid, GridItem, Typography } from '@riac/design-system';
import { GenericPageHeader } from 'src/components/GenericPageHeader';

export type TAccountPageHeaderProps = {
  title: string,
  slug: string,
  description: string,
  titleAddon?: JSX.Element,
}

export const AccountPageHeader = (props: TAccountPageHeaderProps) => {
  return <GenericPageHeader
    title={props.title}
    breadcrumbs={[
      { text: 'Account', slug: '/account' },
      props.slug === '' ? null : { text: props.title, slug: props.slug, },
    ].filter(Boolean)}
    description={props.description}
    titleAddon={props.titleAddon}
  />;
  /*
  <Grid className='mt-0 py-riac-grid text-neutral' style={{background: 'rgba(38, 1, 1, 1)'}}>
    <GridItem type='extended'>
      <div className='flex flex-col gap-5 dark'>
        <Breadcrumb
          textClassName='text-white'
          content={[
            { text: 'Account', slug: '/account' },
            props.slug === '' ? null : { text: props.title, slug: props.slug, },
          ].filter(Boolean)}
        />
        <div className='flex flex-col gap-5'>
          <Typography tag='h1' weight='bold' display>{props.title}</Typography>
          <Typography>
            {props.description}
          </Typography>
        </div>
      </div>
    </GridItem>
  </Grid>*/
}